/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://statefulcoders.com/product/material-dashboard-react
* Copyright 2025 Stateful Coders (https://https://statefulcoders.com)

Coded by https://statefulcoders.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const {
  values: { xs, sm, md, lg, xl, xxl },
} = breakpoints;

const XS = `@media (min-width: ${xs}px)`;
const SM = `@media (min-width: ${sm}px)`;
const MD = `@media (min-width: ${md}px)`;
const LG = `@media (min-width: ${lg}px)`;
const XL = `@media (min-width: ${xl}px)`;
const XXL = `@media (min-width: ${xxl}px)`;

// Mobile-first shared classes
const sharedClasses = {
  marginRight: "auto !important",
  marginLeft: "auto !important",
  width: "100% !important",
  position: "relative",
};

// Mobile-first responsive padding
const mobilePadding = {
  paddingRight: `${pxToRem(16)} !important`,
  paddingLeft: `${pxToRem(16)} !important`,
};

const tabletPadding = {
  paddingRight: `${pxToRem(20)} !important`,
  paddingLeft: `${pxToRem(20)} !important`,
};

const desktopPadding = {
  paddingRight: `${pxToRem(24)} !important`,
  paddingLeft: `${pxToRem(24)} !important`,
};

const container = {
  // Base mobile styles (xs)
  [XS]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      ...mobilePadding,
      maxWidth: "100% !important",
    },
  },

  // Small devices (landscape phones)
  [SM]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      ...tabletPadding,
      maxWidth: "540px !important",
    },
  },

  // Medium devices (tablets)
  [MD]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      ...tabletPadding,
      maxWidth: "720px !important",
    },
  },

  // Large devices (desktops)
  [LG]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      ...desktopPadding,
      maxWidth: "960px !important",
    },
  },

  // Extra large devices
  [XL]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      ...desktopPadding,
      maxWidth: "1140px !important",
    },
  },

  // Extra extra large devices
  [XXL]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      ...desktopPadding,
      maxWidth: "1320px !important",
    },
  },
};

export default container;
